import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import axios from 'axios';

import {
  DataBlocks,
  TextInput,
  I18n,
  Link,
} from 'components';

import ChangePassword from '../ChangePassword';
import OfferPopup from '../../../../components/OfferPopup';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const validateCurrentPassword = (value) => (value ? null : 'settings.passwordAndAccess.emptyPasswordError');

class PasswordSettings extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentPassword: '',
      currentPasswordError: null,
      offerText: '',
      isPopupOpened: false,
    };
  }

  componentDidMount() {
    axios.get('/api/profile/settings/offer/?offerText=true')
      .then((response) => { this.setState({ offerText: response.data.offerText }); });
  }

  onSubmitPassword = (newPassword) => this.props.changePassword({
    newPassword,
    oldPassword: this.state.currentPassword,
  });

  render() {
    const { userLogin, isConvergent, passwordPolicy } = this.props;

    const {
      currentPassword,
      currentPasswordError,
      offerText,
      isPopupOpened,
    } = this.state;

    return (
      <DataBlocks.Block
        title={<I18n path="settings.passwordAndAccess.passwordSettingsTitle" />}
      >
        <div className={cx('container')}>
          <I18n
            className={cx('label')}
            path="settings.passwordAndAccess.login"
          />
          <div className={cx('inputWrapper')}>
            {userLogin}
          </div>
        </div>
        <div className={cx('container', 'currentPassword')}>
          <I18n
            className={cx('label')}
            path="settings.passwordAndAccess.currentPassword"
          />
          <div className={cx('inputWrapper', { fail: !!currentPasswordError })}>
            <TextInput
              type="password"
              value={currentPassword}
              onChange={(value) => this.setState({
                currentPassword: value,
                currentPasswordError: validateCurrentPassword(value),
              })}
              onBlur={(value) => this.setState({
                currentPasswordError: validateCurrentPassword(value),
              })}
            />
            {currentPasswordError
            && (
            <div className={cx('error')}>
              <I18n path={currentPasswordError} />
            </div>
            )}
          </div>
        </div>
        <ChangePassword
          onSubmitPassword={this.onSubmitPassword}
          passwordUpdatingStatus={this.props.passwordUpdatingStatus}
          isConvergent={isConvergent}
          disabled={!currentPassword.length}
          rulesHint={passwordPolicy.text}
          regexp={passwordPolicy.regex}
          userLogin={userLogin}
          currentPassword={currentPassword}
        />
        <div className={cx('offerLink')}>
          <I18n path="settings.passwordAndAccess.firstLoginAgreement" />
          <Link onClick={() => this.setState({ isPopupOpened: true })}>
            <I18n path="settings.passwordAndAccess.mainOfferConditions" />
          </Link>
        </div>
        <OfferPopup
          offerText={offerText}
          isOpened={isPopupOpened}
          onClose={() => this.setState({
            isPopupOpened: false,
          })}
        />
      </DataBlocks.Block>
    );
  }
}

PasswordSettings.propTypes = {
  changePassword: PropTypes.func,
  passwordUpdatingStatus: PropTypes.object,
  userLogin: PropTypes.string,
  isConvergent: PropTypes.bool,
  passwordPolicy: PropTypes.object,
};

export default PasswordSettings;
